(function () {
  /**
   * Toggles 'active' class for data-option elements.
   * In a given scope, removes 'active' from all [data-option] and adds it to the target.
   * @param {HTMLElement|string} target - The element with data-option to set active (or the option value string)
   * @param {HTMLElement} [scope] - Optional container to limit the toggle to (default: document)
   * @returns {string|undefined} - The active option value (data-option), or undefined
   */
  function toggleActiveOption(target, scope) {
    var container = scope || document;
    var options = container.querySelectorAll('[data-option]');
    var el = typeof target === 'string' ? container.querySelector('[data-option="' + target + '"]') : target;
    if (!el) return;
    options.forEach(function (option) {
      option.classList.remove('active');
    });
    el.classList.add('active');
    return el.getAttribute('data-option');
  }

  /**
   * Shows the data-option-content block matching the given option value, hides the rest.
   * @param {string} optionValue - Value matching data-option (e.g. "single", "bundle")
   * @param {HTMLElement} scope - Container (e.g. .pdp-pref)
   */
  function toggleOptionContent(optionValue, scope) {
    var container = scope || document;
    var contentBlocks = container.querySelectorAll('[data-option-content]');
    contentBlocks.forEach(function (block) {
      if (block.getAttribute('data-option-content') === optionValue) {
        block.classList.add('active');
      } else {
        block.classList.remove('active');
      }
    });
  }

  var OPTION_LABELS = { single: 'Alleen het product', bundle: 'Bundel en bespaar' };

  /**
   * Updates the data-option-label element text based on the selected option value.
   * @param {string} optionValue - Value matching data-option (e.g. "single", "bundle")
   * @param {HTMLElement} scope - Container (e.g. .pdp-pref)
   */
  function updateOptionLabel(optionValue, scope) {
    var label = scope ? scope.querySelector('[data-option-label]') : document.querySelector('[data-option-label]');
    if (label && OPTION_LABELS[optionValue] !== undefined) {
      label.textContent = OPTION_LABELS[optionValue];
    }
  }

  /**
   * Shows [data-bundle-options] only when the active option is "bundle", hides otherwise.
   * @param {string} optionValue - Value matching data-option (e.g. "single", "bundle")
   * @param {HTMLElement} scope - Container (e.g. .pdp-pref)
   */
  function toggleBundleOptions(optionValue, scope) {
    var container = scope || document;
    var bundleOptions = container.querySelectorAll('[data-bundle-options]');
    bundleOptions.forEach(function (el) {
      if (optionValue === 'bundle') {
        el.classList.add('active');
      } else {
        el.classList.remove('active');
      }
    });
  }

  /**
   * Shows the inventory pill matching the active option (single | bundle), hides the other.
   * Pills live OUTSIDE .pdp-pref (separate Dawn "inventory" block), so we scope to document.
   * Uses .product__inventory--inactive (not [hidden]/.hidden) so the toggle survives the
   * innerHTML swap product-info.js performs on a variant change.
   * @param {string} optionValue - "single" or "bundle"
   */
  function toggleInventoryState(optionValue) {
    var pills = document.querySelectorAll('[data-inventory-state]');
    pills.forEach(function (pill) {
      var isActive = pill.getAttribute('data-inventory-state') === optionValue;
      pill.classList.toggle('product__inventory--inactive', !isActive);
    });
  }

  /* ---------------- Bundle inventory (which bundle target the pill reflects) ----------------
     The bundle pill shows the WORST-CASE stock of the active bundle target:
     - "combi-kit"            -> main + combi product (server default)
     - "trial-kit-{id}"       -> main + the chosen trial-kit 2nd product
     - "trial-kit-none"       -> main only (trial-kit card active, nothing added yet)
     All statuses are pre-rendered server-side in [data-bundle-inventory-store] as inert
     <template>s, so we never duplicate locale strings / threshold logic in JS. */

  /** @returns {string} active bundle card value ("combi-kit" | "trial-kit"), defaulting to combi-kit. */
  function getActiveBundleCard() {
    var card = document.querySelector('[data-bundle-option].active');
    return card ? card.getAttribute('data-bundle-option') : 'combi-kit';
  }

  /** @returns {string} the bundle-target key the pill should currently reflect. */
  function getCurrentBundleTarget() {
    if (getActiveBundleCard() === 'trial-kit') {
      var id = localStorage.getItem('bundleProductId');
      return id ? 'trial-kit-' + id : 'trial-kit-none';
    }
    return 'combi-kit';
  }

  /**
   * Copies the pre-rendered status for targetKey from the store into the visible bundle pill.
   * Manages .visibility-hidden so an empty (untracked) status keeps its layout placeholder,
   * matching the server-side behaviour of the Dawn inventory block.
   * @param {string} targetKey - e.g. "combi-kit", "trial-kit-123", "trial-kit-none"
   */
  function applyBundleTarget(targetKey) {
    var pill = document.querySelector('[data-inventory-state="bundle"]');
    var store = document.querySelector('[data-bundle-inventory-store]');
    if (!pill || !store) return;
    var tpl = store.querySelector('[data-bundle-target="' + targetKey + '"]');
    if (!tpl) tpl = store.querySelector('[data-bundle-target="combi-kit"]');
    if (!tpl) return;
    pill.innerHTML = tpl.innerHTML;
    pill.setAttribute('data-bundle-target', targetKey);
    var empty = pill.textContent.trim() === '';
    pill.classList.toggle('visibility-hidden', empty);
    if (!empty) pill.classList.remove('hidden');
  }

  /** Re-applies whichever bundle target is currently selected. Safe to call any time. */
  function refreshBundleInventory() {
    applyBundleTarget(getCurrentBundleTarget());
  }

  var BUNDLE_POP_DURATION_MS = 300;

  /**
   * Opens the bundle pop: removes 'hidden', then adds 'active' on next frame so show animation runs.
   * @param {HTMLElement} [scope] - Optional container to find [data-bundle-pop] in (default: document)
   */
  function openBundlePop(scope) {
    var container = scope || document;
    var pop = container.querySelector('[data-bundle-pop]');
    var backdrop = container.querySelector('[data-bundle-pop-backdrop]');
    if (!pop || !backdrop) return;
    pop.classList.remove('hidden');
    backdrop.classList.remove('hidden');
    pop.removeAttribute('hidden');
    backdrop.removeAttribute('hidden');
    requestAnimationFrame(function () {
      pop.classList.add('active');
      backdrop.classList.add('active');
      document.body.classList.add("overflow-hidden-mobile");
    });
  }  

  /**
   * Syncs bundle pop image visibility with the active [data-combineer-input].
   * Gets the image id from the input's data-combineer-input attribute and toggles 'active' on the matching div.
   * @param {HTMLElement} input - The input with data-combineer-input (value = id of image div)
   * @param {HTMLElement} [scope] - Optional container (e.g. [data-bundle-pop]). Default: document
   */
  function syncCombineerImage(input, scope) {
    var container = scope || document;
    var imageId = input.getAttribute('data-combineer-input');
    if (!imageId) return;
    var pop = container.querySelector('[data-bundle-pop]') || document;
    var allImages = pop.querySelectorAll('.pdp-bundle-pop_image');
    allImages.forEach(function (img) {
      img.classList.remove('active');
    });
    var target = document.getElementById(imageId);
    if (target) target.classList.add('active');
  }

  /**
   * Closes the bundle pop: removes 'active' (runs hide animation), then adds 'hidden' after transition ends.
   */
  function closeBundlePop() {
    var pop = document.querySelector('[data-bundle-pop]');
    var backdrop = document.querySelector('[data-bundle-pop-backdrop]');
    if (!pop || !backdrop) return;
    pop.classList.remove('active');
    backdrop.classList.remove('active');
    document.body.classList.remove("overflow-hidden-mobile");
    var done = false;
    function addHidden() {
      if (done) return;
      done = true;
      pop.classList.add("hidden");
      backdrop.classList.add("hidden");
      pop.setAttribute("hidden", "");
      backdrop.setAttribute("hidden", "");
      pop.removeEventListener("transitionend", onEnd);
      document.body.classList.remove("overflow-hidden-mobile");
    }
    function onEnd(e) {
      if (e.target === pop && e.propertyName === 'transform') addHidden();
    }
    pop.addEventListener('transitionend', onEnd);
    setTimeout(addHidden, BUNDLE_POP_DURATION_MS + 50);
  }

  document.querySelectorAll('[data-bundle-pop-close], [data-bundle-pop-backdrop]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      closeBundlePop();
    });
  });

  /* The bundle* localStorage keys are only a same-page-view channel between
     this file and product-form.js (which reads the chosen variant at submit).
     They are purged on every load — the Trial Kit always starts empty and a
     choice made on one product can never leak into another PDP's card. */
  function clearBundleStorage() {
    [
      'bundleProductId',
      'bundleProductImg',
      'bundleVariantId',
      'bundleMainProductId',
      'bundleVariantTitle',
      'bundleVariantPrice',
      'bundleProductPrice',
      'bundleSecondPrice',
      'bundleSecondCompare',
    ].forEach(function (key) {
      localStorage.removeItem(key);
    });
  }

  /**
   * On remove-bundle click: hide added bundle image, show add bundle button, restore default title/price, clear localStorage.
   */
  function handleRemoveBundleClick(scope) {
    var container = scope || document;
    var addedImage = container.querySelector('[data-added-bundle-image]');
    var addButton = container.querySelector('[data-add-bundle-button]');
    var titleEl = container.querySelector('[data-added-bundle-title]');
    var priceEl = container.querySelector('[data-added-bundle-price]');
    if (addedImage) addedImage.classList.add('hidden');
    if (addButton) addButton.classList.remove('hidden');
    if (titleEl) titleEl.innerHTML = '<br>' + (titleEl.getAttribute('data-default-title') || 'Biozakken');
    if (priceEl && priceEl.getAttribute('data-default-price')) priceEl.textContent = priceEl.getAttribute('data-default-price');
    updateBundleAtcState();
    clearBundleStorage();
    updateTrialBadge(container);
    refreshBundleInventory();
  }

  /* ---------------- Kit discount badges (bundle discount %) ----------------
     Each kit card's "X% Korting" shows the REAL bundle discount the checkout
     applies: custom.trial_kit_discount_percent / custom.combi_kit_discount_percent,
     exposed as data attributes on .pdp-pref and enforced at checkout by the
     bundle discount function app (via the _fc_bundle line properties).
     The Trial Kit only counts as a bundle once a 2nd product has been added —
     no partner, no badge, no discount. Compare-at pricing no longer feeds these. */
  function setKitBadge(cardEl, pct) {
    if (!cardEl) return;
    var badge = cardEl.querySelector('.pdp-pref__option-korting');
    if (!badge) return;
    if (pct > 0) {
      var text = pct + '% Korting';
      if (badge.textContent !== text) badge.textContent = text;
      badge.classList.remove('pdp-pref__option-korting--hidden');
    } else {
      badge.classList.add('pdp-pref__option-korting--hidden');
    }
  }

  function getPrefRoot(scope) {
    if (scope && scope.nodeType === 1 && scope.classList.contains('pdp-pref')) return scope;
    return document.querySelector('.pdp-pref');
  }

  function rootDiscountPercent(root, attr) {
    var pct = parseFloat(root.getAttribute(attr));
    return isNaN(pct) || pct <= 0 ? 0 : Math.round(pct);
  }

  function updateCombiBadge(scope) {
    var root = getPrefRoot(scope);
    if (!root) return;
    var combi = root.querySelector('[data-bundle-option="combi-kit"]');
    if (!combi) return;
    setKitBadge(combi, rootDiscountPercent(root, 'data-combi-discount-percent'));
  }

  function updateTrialBadge(scope) {
    var root = getPrefRoot(scope);
    if (!root) return;
    var trial = root.querySelector('[data-bundle-option="trial-kit"]');
    if (!trial) return;
    var addedImage = root.querySelector('[data-added-bundle-image]');
    var hasPartner = addedImage && !addedImage.classList.contains('hidden');
    setKitBadge(trial, hasPartner ? rootDiscountPercent(root, 'data-trial-discount-percent') : 0);
  }

  function updateKitBadges(scope) {
    updateCombiBadge(scope);
    updateTrialBadge(scope);
  }

  /* ---------------- Trial Kit ATC gating ----------------
     The Trial Kit is a two-product bundle: until a 2nd product is added the
     add-to-cart is blocked (enforced in product-form.js#proceedWithAdd, which
     also opens the picker). This only mirrors that state visually on the main
     and sticky buttons — they stay clickable so the block can explain itself. */
  function trialKitNeedsPartner() {
    var pref = document.querySelector('.pdp-pref:not(.pdp-pref--regular)');
    if (!pref) return false;
    var pkg = pref.querySelector('[data-option].active');
    if (pkg && pkg.getAttribute('data-option') !== 'bundle') return false;
    var kit = pref.querySelector('[data-bundle-option].active');
    if (!kit || kit.getAttribute('data-bundle-option') !== 'trial-kit') return false;
    var added = pref.querySelector('[data-added-bundle-image]');
    return !added || added.classList.contains('hidden');
  }

  function updateBundleAtcState() {
    var needs = trialKitNeedsPartner();
    var productInfo = document.querySelector('product-info[id^="MainProduct-"]');
    var mainSubmit = productInfo
      ? productInfo.querySelector('form[data-type="add-to-cart-form"] .product-form__submit')
      : null;
    [mainSubmit, document.getElementById('StickyProductSubmit')].forEach(function (btn) {
      if (btn) btn.classList.toggle('product-form__submit--needs-partner', needs);
    });
  }

  document.querySelectorAll('[data-remove-bundle-button]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pref = btn.closest('.pdp-pref') || document;
      handleRemoveBundleClick(pref);
    });
  });

  /**
   * On add-bundle submit: save selected product id and img src to localStorage,
   * update [data-added-bundle-image] img, show added image and hide add button.
   */
  function handleAddBundleSubmit() {
    var pop = document.querySelector('[data-bundle-pop]');
    if (!pop) return;
    var checkedInput = pop.querySelector('[data-combineer-product-id]:checked');
    if (!checkedInput) return;
    var productId = checkedInput.getAttribute('data-combineer-product-id');
    var variantId = checkedInput.getAttribute('data-combineer-variant-id');
    var variantTitle = checkedInput.getAttribute('data-combineer-variant-title');
    var combinedPrice = checkedInput.getAttribute('data-combineer-combined-price');
    var mainProductId = pop.getAttribute('data-main-product-id');
    var row = checkedInput.closest('label') || checkedInput.closest('.pdp-pref__variant');
    var img = row ? row.querySelector('img') : null;
    var imgSrc = img ? img.src : '';
    if (productId) localStorage.setItem('bundleProductId', productId);
    if (variantId) localStorage.setItem('bundleVariantId', variantId);
    if (mainProductId) localStorage.setItem('bundleMainProductId', mainProductId);
    if (variantTitle) localStorage.setItem('bundleVariantTitle', variantTitle);
    if (combinedPrice) localStorage.setItem('bundleProductPrice', combinedPrice);
    if (imgSrc) localStorage.setItem('bundleProductImg', imgSrc);
    var addedImageEl = document.querySelector('[data-added-bundle-image]');
    var addButtonEl = document.querySelector('[data-add-bundle-button]');
    var addedTitleEl = document.querySelector('[data-added-bundle-title]');
    var addedPriceEl = document.querySelector('[data-added-bundle-price]');
    if (addedImageEl) {
      var addedImg = addedImageEl.querySelector('img');
      if (addedImg && imgSrc) addedImg.src = imgSrc;
      addedImageEl.classList.remove('hidden');
      addedImageEl.classList.add('pdp-pref__option-image--animate-in');
      setTimeout(function () {
        addedImageEl.classList.remove('pdp-pref__option-image--animate-in');
      }, 350);
    }
    if (addButtonEl) addButtonEl.classList.add('hidden');
    if (addedTitleEl && variantTitle) addedTitleEl.textContent = variantTitle;
    if (addedPriceEl && combinedPrice) addedPriceEl.textContent = combinedPrice;
    updateTrialBadge();
    updateBundleAtcState();
    refreshBundleInventory();
    closeBundlePop();
  }

  document.querySelectorAll('[data-add-bundle-submit-button]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      handleAddBundleSubmit();
    });
  });

  /**
   * Toggles 'active' class for [data-bundle-option] elements.
   * Within the given scope, removes 'active' from all [data-bundle-option] and adds it to the target.
   * @param {HTMLElement|string} target - The element with data-bundle-option to set active (or the option value string)
   * @param {HTMLElement} [scope] - Container with [data-bundle-options] to limit the toggle to
   * @returns {string|undefined} - The active bundle option value (data-bundle-option), or undefined
   */
  function toggleActiveBundleOption(target, scope) {
    var container = scope || document;
    var options = container.querySelectorAll('[data-bundle-option]');
    var el = typeof target === 'string'
      ? container.querySelector('[data-bundle-option="' + target + '"]')
      : target;
    if (!el) return;
    options.forEach(function (option) {
      option.classList.remove('active');
    });
    el.classList.add('active');
    return el.getAttribute('data-bundle-option');
  }

  document.querySelectorAll('.pdp-pref').forEach(function (pref) {
    pref.querySelectorAll('[data-option]').forEach(function (option) {
      option.addEventListener('click', function () {
        var value = toggleActiveOption(this, pref);
        if (value) {
          toggleOptionContent(value, pref);
          updateOptionLabel(value, pref);
          toggleBundleOptions(value, pref);
          toggleInventoryState(value);
          refreshBundleInventory();
          updateBundleAtcState();
        }
      });
    });
    var activeOption = pref.querySelector('[data-option].active');
    if (activeOption) {
      var value = activeOption.getAttribute('data-option');
      toggleOptionContent(value, pref);
      updateOptionLabel(value, pref);
      toggleBundleOptions(value, pref);
      toggleInventoryState(value);
      refreshBundleInventory();
    }

    pref.querySelectorAll('[data-bundle-options]').forEach(function (bundleOptionsEl) {
      bundleOptionsEl.querySelectorAll('[data-bundle-option]').forEach(function (bundleOption) {
        bundleOption.addEventListener('click', function () {
          toggleActiveBundleOption(this, bundleOptionsEl);
          refreshBundleInventory();
          updateBundleAtcState();
        });
      });
    });

    pref.querySelectorAll('[data-add-bundle-button]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openBundlePop(document);
      });
    });
  });

  document.querySelectorAll('[data-combineer-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      syncCombineerImage(this, document);
    });
  });

  /**
   * Wires up horizontal scroll arrows for a variants scroller.
   * Arrows scroll the content left/right and auto-hide when there is no overflow
   * or when the content is already scrolled to the matching edge.
   * @param {HTMLElement} scroller - The [data-bundle-pop-scroller] wrapper
   */
  function initVariantsScroller(scroller) {
    var content = scroller.querySelector('[data-bundle-pop-scroll-content]');
    var prevBtn = scroller.querySelector('[data-bundle-pop-scroll="prev"]');
    var nextBtn = scroller.querySelector('[data-bundle-pop-scroll="next"]');
    if (!content) return;

    function updateArrows() {
      var maxScroll = content.scrollWidth - content.clientWidth;
      var hasOverflow = maxScroll > 1;
      var atStart = content.scrollLeft <= 1;
      var atEnd = content.scrollLeft >= maxScroll - 1;
      if (prevBtn) prevBtn.hidden = !hasOverflow || atStart;
      if (nextBtn) nextBtn.hidden = !hasOverflow || atEnd;
    }

    function scrollByAmount(direction) {
      var amount = Math.max(content.clientWidth * 0.8, 160);
      content.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByAmount(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByAmount(1); });
    content.addEventListener('scroll', updateArrows);

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateArrows).observe(content);
    } else {
      window.addEventListener('resize', updateArrows);
    }

    // Recalculate when the bundle pop opens (content may be measured while hidden).
    var pop = scroller.closest('[data-bundle-pop]');
    if (pop) {
      new MutationObserver(function () {
        if (!pop.classList.contains('hidden')) updateArrows();
      }).observe(pop, { attributes: true, attributeFilter: ['class'] });
    }

    updateArrows();
  }

  document.querySelectorAll('[data-bundle-pop-scroller]').forEach(initVariantsScroller);

  clearBundleStorage();
  updateKitBadges();
  updateBundleAtcState();
  refreshBundleInventory();

  // Back/forward (bfcache) restores the previous DOM without reloading — reset
  // the Trial Kit to its server-rendered empty default, matching a fresh visit.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var pref = document.querySelector('.pdp-pref');
    if (pref) handleRemoveBundleClick(pref);
  });

  // When product-info.js re-renders the inventory store on a variant change, re-apply the
  // currently selected bundle target so the pill reflects the new variant's worst-case stock.
  var inventoryStore = document.querySelector('[data-bundle-inventory-store]');
  if (inventoryStore && typeof MutationObserver !== 'undefined') {
    new MutationObserver(function () {
      refreshBundleInventory();
    }).observe(inventoryStore, { childList: true, subtree: true });
  }
})();